var exports = {
  "k": "xf0b3b88a--306548--container",
  "P": "xf0b3b88a--306548--label",
};

module.exports = exports;
